import { BilletActions } from "../actions";

const initialState = {
  billetGeneralInformation: null,
  billets: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
  billetGenerationHistory: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
};

export default function billet(state = initialState, action) {
  switch (action.type) {
    case BilletActions.ACTION_SAVE_BILLETS:
      return {
        ...state,
        billets: action.payload,
      };
    case BilletActions.ACTION_SAVE_BILLET_GENERAL_INFORMATION:
      return {
        ...state,
        billetGeneralInformation: action.payload,
      };

    case BilletActions.ACTION_SAVE_BILLET_GENERATION_HISTORY:
      return {
        ...state,
        billetGenerationHistory: action.payload,
      };
    default:
      return state;
  }
}

export function getBilletGeneralInformation(state) {
  return state.billet.billetGeneralInformation;
}

export function getBillets(state) {
  return state.billet.billets;
}

export function getBilletGenerationHistory(state) {
  return state.billet.billetGenerationHistory;
}
